module.exports = __webpack_public_path__ + "static/img/6农机农艺融合.7974bc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/解决方案/农机无人驾驶解决方案/6农机农艺融合.png
// module id = pE91
// module chunks = 0